export default "__VITE_ASSET__fd1afcee__"